const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

//const Backofficebff         : string = "/api/v1";

export const RefundRestQuery: any = {
    petitionrefundlist: Backofficebff + '/v1/refundrest/petitionrefundlist',
    createPetitionRest: Backofficebff + '/v1/refundrest/CreatePetitionRest',
    createPetitionV2: Backofficebff + '/v1/refundrest/create-petition-v2',
    exportSerbiaBankTxt: Backofficebff + '/v1/refundrest/export-serbia-bank-txt',
    refundHistory: Backofficebff + '/v1/refundrest/refundhistory',
    refundList: Backofficebff + '/v1/refundrest/refundlist',
    lcwMoneyCashRefund: Backofficebff + '/v1/refundrest/lcwmoneycashrefund',
    paymentList: Backofficebff + '/v1/refundrest/paymentlist',
    getRefundDetails: Backofficebff + '/v1/refundrest/getRefundDetails',
    getAllRefundDetailsForOrder: Backofficebff + '/v1/refundrest/getallrefunddetailsfororder',
    doRefundPendings: Backofficebff + '/v1/refundrest/dorefundpendings',
    paybackList: Backofficebff + '/v1/refundrest/paybacklist',
    getRefundOfReturnForClient: Backofficebff + '/v1/refundrest/getrefundofreturnforclient',
    convertPaybackToLcwMoney: Backofficebff + '/v1/refundrest/convertpaybacktolcwmoney',
    updatewirecustomerchoice: Backofficebff + '/v1/refundrest/updatewirecustomerchoice',
    checkOperatorFromRuleService: Backofficebff + '/v1/refundrest/check-operator-from-rule-service',
    convertPaybackToBankTransfer: Backofficebff + '/v1/refundrest/convert-payback-to-bank-transfer',
    getRefundMethodValidation: Backofficebff + '/v1/refundrest/get-refund-method-validation',
    GetRefundPageRuleFromServiceForLcwMoney:
        Backofficebff + '/v1/refundrest/get-refund-page-rule-from-service-for-lcw-money',
    getAkbankTransactionStatusList: Backofficebff + '/v1/refundrest/get-akbank-transaction-status-list',
    checkPaymentConversionCloseRefundRole:
        Backofficebff + '/v1/refundrest/check-payment-conversion-close-refund-role',
    getRefundReceiptPdf: Backofficebff + '/v1/refundrest/get-refund-receipt-pdf',
};
